import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Spread from '../../../components/Editor/Spread';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			type,
			pagesController: { spreads, currentSpreadIndex, prevSpreadIndex },
			pages,
			thumbnails,
			spreadZoom,
			resources: { scripts },
			externalResources,
			isAccessibleVersion,
		},
	} = state;
	const prevSpreadFirstPage = !isAccessibleVersion ? spreads[prevSpreadIndex][0] : prevSpreadIndex + 1;
	const currentSpreadFirstPage = !isAccessibleVersion ? spreads[currentSpreadIndex][0] : currentSpreadIndex + 1;
	const page = pages[currentSpreadFirstPage] ? currentSpreadFirstPage : prevSpreadFirstPage;
	const { width: pageWidth, height: pageHeight, externalId } = !isAccessibleVersion ? pages[page] : pages[currentSpreadIndex + 1];

	return {
		editorType: type,
		spread: spreads[currentSpreadIndex],
		pageWidth,
		pageHeight,
		zoom: spreadZoom,
		isThumbnailsDisplayed: thumbnails.isDisplayed,
		thumbnailsWidth: thumbnails.width,
		scripts: externalId ? externalResources[externalId].scripts : scripts,
		isAccessibleVersion,
		currentSpreadIndex,
	};
};

export default connect(mapStateToProps)(Spread);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Spread/index.tsx